import React, { forwardRef, useEffect } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useLanguage } from '@/i18n/LanguageContext';

interface CalendlyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CalendlyModal = forwardRef<HTMLDivElement, CalendlyModalProps>(({ isOpen, onClose }, ref) => {
  const { t, language } = useLanguage();
  const description = language === 'fr'
    ? "Choisissez un créneau d'échange avec l'équipe ConsulTIC."
    : language === 'nl'
    ? 'Kies een gesprekstijd met het ConsulTIC-team.'
    : 'Choose a meeting slot with the ConsulTIC team.';

  useEffect(() => {
    if (isOpen) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent ref={ref} closeLabel={t.accessibility.closeDialog} className="sm:max-w-[700px] h-[700px] p-0 overflow-hidden">
        <DialogHeader className="p-6 pb-0">
          <DialogTitle className="text-xl font-display font-bold text-primary">
            {t.calendly.title}
          </DialogTitle>
          <DialogDescription className="sr-only">
            {description}
          </DialogDescription>
        </DialogHeader>
        <div className="flex-1 h-full min-h-[600px]">
          <div
            className="calendly-inline-widget w-full h-full"
            data-url="https://calendly.com/sarah-rousseau/entretien-service-commercial?hide_gdpr_banner=1&background_color=ffffff&text_color=004581&primary_color=009EE0"
            style={{ minWidth: '320px', height: '600px' }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
});

CalendlyModal.displayName = 'CalendlyModal';
